import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import { STRINGS_MESSAGE_BUNDLE_NAME } from './constants';
import ArbBundleContext from './ArbBundleContext';

interface ArbBundleProviderProps {
  /**
   * Component to render while the resource bundle is loading.
   */
  fallback: React.ReactNode;
  children: React.ReactNode;
}

/**
 * A wrapper over the `ArbBundleContext` allowing presentation of a loading
 * component while the resource bundle is being loaded. This provider should
 * be specified once near the top of the component tree.
 */
export const ArbBundleProvider: React.FC<ArbBundleProviderProps> = (props) => {
  const [bundle, isBundleLoading] = useBundle(STRINGS_MESSAGE_BUNDLE_NAME);

  if (isBundleLoading) {
    return props.fallback;
  }

  return (
    <ArbBundleContext.Provider value={bundle}>
      {props.children}
    </ArbBundleContext.Provider>
  );
};
